// Texty vlastního našeptávače (whispererRender.js).
import { plural } from '../plural.js';

export default {
  suggests: 'Našeptané dotazy',
  popularQueries: 'Nejhledanější',
  products: 'Produkty',
  popularProducts: 'Populární produkty',
  hint: '↑ ↓ pohyb · Enter otevře',
  cart: 'Do košíku',
  top: 'Top',
  // Popisky sekcí obsahu. Klíč = `kind` z modelu (viz `searchWhisperer.js`).
  groups: {
    cat: 'Kategorie',
    brand: 'Značky',
    article: 'Články',
    page: 'Stránky',
  },
  /** „24 výsledků" do nadpisu pravého sloupce. */
  resultsCount: (total) => total + ' ' + plural(total, ['výsledek', 'výsledky', 'výsledků']),
  /** „Zobrazit všech 24 výsledků" — čeština má tři tvary, ne dva. */
  resultsCta: (total) => {
    const prefix = total === 1 ? 'Zobrazit ' : total >= 2 && total <= 4 ? 'Zobrazit všechny ' : 'Zobrazit všech ';
    return prefix + total + ' ' + plural(total, ['výsledek', 'výsledky', 'výsledků']);
  },
};
